var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tv-solid",
    className: "cls-1",
    d: "M33.3,0H2.7C1.209,0,0,1.511,0,3.375v22.5c0,1.864,1.209,3.375,2.7,3.375H16.2V31.5H6.3a1.032,1.032,0,0,0-.9,1.125v2.25A1.032,1.032,0,0,0,6.3,36H29.7a1.032,1.032,0,0,0,.9-1.125v-2.25a1.032,1.032,0,0,0-.9-1.125H19.8V29.25H33.3c1.491,0,2.7-1.511,2.7-3.375V3.375C36,1.511,34.791,0,33.3,0Zm-.9,24.75H3.6V4.5H32.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebWhite);
export default __webpack_public_path__ + "static/media/web-white.0a3cfa5ca9ae78b9eb510d8559c329fd.svg";
export { ForwardRef as ReactComponent };